export default __webpack_public_path__ + "static/media/logo-regenesis-footer.64ebf08e.svg";